<div @click="onClick" class="ml-auto font-bold underline text-blue-500 hover:text-blue-700 hover:cursor-pointer">
  {{label}}
</div>